import { render } from "./Drafts.vue?vue&type=template&id=6abb9b74&scoped=true&ts=true"
import script from "./Drafts.vue?vue&type=script&lang=ts"
export * from "./Drafts.vue?vue&type=script&lang=ts"

import "./Drafts.vue?vue&type=style&index=0&id=6abb9b74&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abb9b74"]])

export default __exports__